import React, { useState, useEffect } from 'react';
import logo from '../../assets/images/logo.png';
import '../navbar/navbar.css';
import { useLocation } from 'react-router-dom';
import { IconContext } from 'react-icons';
import Profile from '../profile/Profile';
import Sidebar from '../sidebar/Sidebar';
import { useSelector } from 'react-redux';
import { isMobile, isTablet, isDesktop } from 'react-device-detect';

const Navbar = () => {
  const location = useLocation()
  const [sidebar, setSidebar] = useState(true)
  const [user, setUser] = useState([])
  const [permisos, setPermisos] = useState([])
  const showSidebar = () => setSidebar(!sidebar)
  const isIdle = useSelector((state) => state.idle.isIdle)

  useEffect(() => {
    const userTemp = JSON.parse(localStorage.getItem('user'))

    if (userTemp) {
      setUser(userTemp)
      setPermisos(userTemp.Permisos);
    }

    if (window.innerWidth < 900) {
      setSidebar(false)
    }
  }, []);

  // change active index.
  useEffect(() => {
    const content = document.getElementById('content')
    if (sidebar) 
      content.classList.remove('ps-0')
    else content.classList.add('ps-0')
    
  }, [location, permisos, sidebar])

  window.addEventListener('resize', () => {
    if (window.innerWidth < 900) 
      setSidebar(false) 
    else setSidebar(true)
  })

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Profile mostrarSidebar={showSidebar} />
        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
          <ul className='nav-menu-items'>
            <li className='navbar-toggle'>
              <img src={logo} alt='logo' className='App-logo'></img>
              <h6 className='user-logged mt-2 text-white px-1'>{user.Nombre}</h6>
              <div className='user-logged d-flex w-100 justify-content-center align-items-end'>
                {isIdle ? (
                  <>
                    <i className='bx bxs-circle text-danger'></i>
                    <h6 className='user-logged text-danger mb-0 ms-1'>Fuera de línea</h6>
                  </>
                ) : (
                  <>
                    <i className='bx bxs-circle bx-flashing text-teal'></i>
                    <h6 className='user-logged text-teal mb-0 ms-1'>En línea</h6>
                  </>
                )}

              </div>              

              <div className='d-flex flex-column justify-content-center align-items-center my-2'>
                {isMobile && <h6 className='user-logged text-teal mb-0 ms-1'>Estás usando un teléfono móvil</h6>}
                {isTablet && <h6 className='user-logged text-danger mb-0 ms-1'>Estás usando una tablet</h6>}
                {isDesktop && <h6 className='user-logged text-warning mb-0 ms-1'>Estás usando una computadora</h6>}
              </div>
            </li>
            
            <Sidebar data={permisos} />
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;